/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Meta_DescriptionInputs */

const es_login_meta_description = /** @type {(inputs: Login_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicia sesion en Nexata. Accede a tu asistente empresarial con IA.`)
};

const en_login_meta_description = /** @type {(inputs: Login_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to Nexata. Access your AI-powered business assistant.`)
};

/**
* | output |
* | --- |
* | "Sign in to Nexata. Access your AI-powered business assistant." |
*
* @param {Login_Meta_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const login_meta_description = /** @type {((inputs?: Login_Meta_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Meta_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_login_meta_description(inputs)
	return en_login_meta_description(inputs)
});
export { login_meta_description as "login.meta.description" }